import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router';

import { Page } from 'components/layout';
import { PropertyForm } from 'components/blocks/Property';
import DetailScreen from './DetailScreen';

const PropertyDetailScreen = ({ history, property, actions, match }) => {
  useEffect(() => {
    actions.property.detailLoad({ id: match.params.propertyId });
  }, [match.params.propertyId, actions.property]);

  const id = match.params.propertyId;
  const detail = property.detail || {};

  return (
    <Page
      isLoading={property.loadDetailStatus.isLoading}
      detail={detail}
      title={detail.name}
      modelActions={actions.property}
      breadcrumbs={[
        { title: 'Свойства товаров', path: property.urls.list() },
        { title: detail.name, path: property.urls.detail(id) },
      ]}
      actions={[
        { mode: 'button', name: 'edit' },
        {
          mode: 'group',
          actions: [{ mode: 'button', name: 'delete' }],
        },
      ]}
      basePath={property.urls.detail(id)}
    >
      <Route exact path="/catalog/property/:propertyId" component={DetailScreen} />

      <PropertyForm />
    </Page>
  );
};

const mapState = (state) => ({
  property: state.property,
});

const mapDispatch = (dispatch) => ({
  actions: {
    property: dispatch.property,
  },
});

export default connect(mapState, mapDispatch)(PropertyDetailScreen);
